export default __webpack_public_path__ + "static/media/qaqn.9ff66b02.png";